/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DraftArticleResponseBasePage } from '../../models/draft-article-response-base-page';

export interface ListDraftArticles$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'title' | '-title' | 'userId' | '-userId' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'data' | '-data'>;
}

export function listDraftArticles(http: HttpClient, rootUrl: string, params?: ListDraftArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<DraftArticleResponseBasePage>> {
  const rb = new RequestBuilder(rootUrl, listDraftArticles.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DraftArticleResponseBasePage>;
    })
  );
}

listDraftArticles.PATH = '/v0/draft-articles';
